/**
 * @fileoverview Own the local email-signature draft and connect `SignatureForm.js` to `SignaturePreview.js`. Shared schema/utilities define fields and output. This workspace generates copyable presentation without persisting employee identity or changing a provider's installed signature.
 */

import React, { useState } from 'react';
import SignatureForm from './SignatureForm';
import SignaturePreview from './SignaturePreview';
import { AppPageHeader } from '../../shared';
import './SignatureGenerator.css';



const SignatureGenerator = () => {
    const [signatureData, setSignatureData] = useState({
        name: "",
        title: "",
        isAttorney: false,
        licenseStates: [],
        officePhone: "",
        mobilePhone: "",
        email: "",
        address: "",
    });

    return (
        <div>
            <AppPageHeader
                eyebrow="Workspace Tools"
                title="Email Signature Generator"
                icon="pi pi-envelope text-xl"
            />
            <div className="px-4 pb-5">
                <div className="signature-generator__panel p-4 border-1 border-round">
                    <div className="grid">
                        <div className="col-12">
                            <SignatureForm onDataChange={setSignatureData} formData={signatureData} />
                        </div>

                        <div className="surface-border border-top-1 opacity-50 my-5 col-12"></div>

                        <div className="col-12">
                            <SignaturePreview data={signatureData} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignatureGenerator;
